module.exports = __webpack_public_path__ + "img/slider_medical_contact.f5376966.svg";